var render, staticRenderFns
import script from "./ProcessRender.vue?vue&type=script&lang=js"
export * from "./ProcessRender.vue?vue&type=script&lang=js"
import style0 from "./ProcessRender.vue?vue&type=style&index=0&id=2ad64fc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad64fc7",
  null
  
)

export default component.exports